import { Box, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const RescheduleNoticeBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
  padding: uni('scale-400'),
  borderRadius: uni('border-radius-sm'),
  backgroundColor: uni('bg-primary-subtle-rest'),
}));

export const RescheduleNoticeLine = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: uni('scale-200'),
  color: uni('fg-neutral-action-on-color-subtle-rest'),

  [tabletBreakpoint]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: uni('scale-100'),
  },
}));

/** The value inside the message comes wrapped in a <span> so it can carry the lighter weight. */
export const RescheduleNoticeText = styled('p')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-action-on-color-subtle-rest')};
  margin: 0;

  span {
    ${uniTypography('text-sm', 'medium')}
  }
`;
